module.exports = __webpack_public_path__ + "static/media/screenshot@2x.6a961e8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/screenshot@2x.png
// module id = 900
// module chunks = 0